import { animate, style, transition, trigger } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-pop-up-content',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 })),
      ]),
      transition(':leave', [
        // :leave is alias to '* => void'
        animate(500, style({ opacity: 0 })),
      ]),
    ]),
  ],
  templateUrl: './edit-pop-up-content.component.html',
  styleUrls: ['./edit-pop-up-content.component.scss'],
})
export class EditPopUpContentsComponent implements OnInit {
  EditPopUpModel: any = {};
  id;
  isEditingPopUp;
  isUploadImage;
  imageSrc;
  isLoadingPopUp;
  isVideo;
  isUploadImage2;
  imageSrc2;
  isVideo2;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private TokenService: TokenService,
    private http: HttpClient
  ) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['PopupContents']) {
      router.navigateByUrl('/');
    }
  }

  ngOnInit() {
    this.activeRoute.queryParams.subscribe((x) => {
      this.id = x['id'];
    });
    this.GetPopUp();
  }

  GetPopUp() {
    this.isLoadingPopUp = false;
    this.http
      .get<any>(environment.url + 'PopUp/GetAllPopups')
      .subscribe((data) => {
        data.Data.forEach((element) => {
          if (element.Ref == this.id) {
            setTimeout(() => {
              this.EditPopUpModel = element;
              if (
                this.EditPopUpModel.PopupImage.substring(
                  this.EditPopUpModel.PopupImage.length - 3
                ) == 'mp4'
              )
                this.isVideo = true;
              else this.isVideo = false;
              this.imageSrc = element.PopupImage;
              this.isLoadingPopUp = true;
            }, 1000);
          }
        });
      });
  }

  openImage(id = 'addimage') {
    // Click Image File Button
    let element: HTMLElement = document.getElementById(id) as HTMLElement;
    element.click();
  }
  addImageChange(files: FileList) {
    // Show Image File on change
    this.isUploadImage = true;

    const formData = new FormData();
    if (files) {
      formData.append('file', files[0]);
    }
    this.http
      .post<any>(environment.url + 'PopUp/UploadImage', formData)
      .subscribe((data) => {
        this.isUploadImage = false;
        if (data) {
          if (files) {
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
              this.imageSrc = reader.result as string;
              this.EditPopUpModel.PopupImage = data;
              if (
                this.EditPopUpModel.PopupImage.substring(
                  this.EditPopUpModel.PopupImage.length - 3
                ) == 'mp4'
              )
                this.isVideo = true;
              else this.isVideo = false;
            };
          }
          this.toastr.success('Dosya Yüklendi', '', {
            timeOut: 3000,
          });
        } else {
          this.toastr.error('Dosya Yüklenemedi', 'Hata !', {
            timeOut: 3000,
          });
        }
      });
  }

  addImageChange2(files: FileList) {
    // Show Image File on change
    this.isUploadImage2 = true;

    const formData = new FormData();
    if (files) {
      formData.append('file', files[0]);
    }
    this.http
      .post<any>(environment.url + 'PopUp/UploadImage', formData)
      .subscribe((data) => {
        this.isUploadImage2 = false;
        if (data) {
          if (files) {
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
              this.imageSrc2 = reader.result as string;
              this.EditPopUpModel.PopupLogo = data;
              if (
                this.EditPopUpModel.PopupLogo.substring(
                  this.EditPopUpModel.PopupLogo.length - 3
                ) == 'mp4'
              )
                this.isVideo2 = true;
              else this.isVideo2 = false;
            };
          }
          this.toastr.success('Dosya Yüklendi', '', {
            timeOut: 3000,
          });
        } else {
          this.toastr.error('Dosya Yüklenemedi', 'Hata !', {
            timeOut: 3000,
          });
        }
      });
  }

  PopupChange(value) {
    if (value) this.EditPopUpModel.PopupCounter += 1;
    else this.EditPopUpModel.PopupCounter -= 1;
  }

  EditPopup() {
    this.isEditingPopUp = true;
    this.http
      .post<any>(environment.url + 'PopUp/EditPopup', this.EditPopUpModel)
      .subscribe((data) => {
        if (data) {
          this.isEditingPopUp = false;
          this.toastr.success('Popup Güncellendi.', '', {
            timeOut: 3000,
          });
          this.router.navigate(['/home/cms/pop-up-contents']);
        } else {
          this.isEditingPopUp = false;
          this.toastr.error('Popup Güncellenemedi.', 'Hata !', {
            timeOut: 3000,
          });
        }
      });
  }
}
